module.exports = __webpack_public_path__ + "static/keeping-his-head-in-the-game-menu-6b577c6279caf54933665bbb0875d0ad.jpg";